<template>
	<td><slot></slot></td>
</template>
<script>
	export default {
		name: 'TableCell',
	}
</script>


// WEBPACK FOOTER //
// src/components/TableCell.vue